import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { Methods } from "../../Constants/ApiConstants";
import Api from "../../api/generalApi/Api";
import i18n from "../../i18n";
import { GeneralResponse } from "../../interface/GeneralResponse";

interface UseGetDataFilter {
  [key: string]: string | number | boolean;
}

export interface IQueryOptions<T>
  extends Omit<
    UseQueryOptions<GeneralResponse<T>, Error>,
    "queryKey" | "queryFn"
  > {
  filter?: UseGetDataFilter;
}

const buildUrlWithParams = (
  baseUrl: string,
  params?: UseGetDataFilter,
): string => {
  if (!params || Object.keys(params).length === 0) {
    return baseUrl;
  }

  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      queryParams.append(key, String(value));
    }
  });

  const queryString = queryParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

const useGetData = <T>(
  endpoint: string,
  options: IQueryOptions<T> = {},
  Id?: string | number,
) => {
  return useQuery<GeneralResponse<T>, Error>({
    queryKey: [endpoint, Id, options.filter, i18n?.language],

    queryFn: async (): Promise<GeneralResponse<T>> => {
      const urlWithParams = buildUrlWithParams(
        Id ? `${endpoint}/${Id}` : endpoint,
        options.filter,
      );

      return Api<undefined, GeneralResponse<T>>({
        method: Methods.GET,
        endpoint: urlWithParams,
      });
    },

    refetchOnMount: true,
    refetchOnWindowFocus: true,
    ...options,
  });
};
export default useGetData;